import * as Sentry from '@sentry/react'

Sentry.init({
    dsn: 'https://45f246f0c75676d9c519c7dcb00f3590@o1313594.ingest.us.sentry.io/4510908010004480',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0.01,
    tracePropagationTargets: [
        /^https:\/\/(?:api|backoffice-engine|retailers-engine)\.baltic-watches\.com(?:\/|$)/,
    ],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
    enabled: import.meta.env.PROD && window.location.hostname.endsWith('.com'),
    ignoreErrors: [
        // Network / loading failures
        'Load failed',
        'Failed to fetch',
        /ChunkLoadError/,
        /Loading chunk [\d]+ failed/,
        // Non-actionable browser errors
        /Non-Error promise rejection captured with keys/,
        /ResizeObserver loop/,
        // Chrome translate breaking React DOM
        /Failed to execute 'removeChild' on 'Node'/,
        /Failed to execute 'insertBefore' on 'Node'/,
        // Firefox extension errors
        /can't access dead object/,
        // Safari WebKit internal
        /AbortError/,
    ],
    denyUrls: [
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        /^moz-extension:\/\//i,
        /^safari-extension:\/\//i,
    ],
})
